import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';
import type { MyWorkspaceListItemResponse } from '@core/api/workspace/models';
import {
  formatWorkspaceRole,
  resolveWorkspaceAvatarClass,
  resolveWorkspaceInitial,
} from '@core/utils/workspace-avatar.util';

@Component({
  selector: 'app-workspace-card',
  imports: [NgClass],
  templateUrl: './workspace-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkspaceCardComponent {
  readonly workspace = input.required<MyWorkspaceListItemResponse>();

  readonly initial = computed(() => resolveWorkspaceInitial(this.workspace().name));

  readonly avatarClass = computed(() =>
    resolveWorkspaceAvatarClass(
      this.workspace().workspaceSlug ?? this.workspace().id ?? this.workspace().name,
    ),
  );

  readonly roleLabel = computed(() => formatWorkspaceRole(this.workspace().role));
}
